/**
 * Pub/sub event bus — the backbone of inter-module communication.
 * Usage:
 *   EventBus.on('ship:arrived', handler);
 *   EventBus.emit('ship:arrived', { ship, port });
 *   EventBus.off('ship:arrived', handler);
 */
class EventBusClass {
  constructor() {
    this.listeners = new Map();
  }

  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);
    return this; // chainable
  }

  off(event, callback) {
    const callbacks = this.listeners.get(event);
    if (callbacks) {
      const idx = callbacks.indexOf(callback);
      if (idx > -1) callbacks.splice(idx, 1);
    }
    return this;
  }

  emit(event, data) {
    const callbacks = this.listeners.get(event) || [];
    for (const cb of callbacks) {
      try {
        cb(data);
      } catch (err) {
        console.error(`[EventBus] Error in "${event}" handler:`, err);
      }
    }
  }

  /** Remove all listeners for an event (useful for cleanup) */
  clear(event) {
    if (event) {
      this.listeners.delete(event);
    } else {
      this.listeners.clear();
    }
  }
}

export const EventBus = new EventBusClass();
